export enum REPAIR_STATUS {
  Created = "Created",
  Assigned = "Assigned",
  InProgress = "InProgress",
  Requested = "Requested",
  OnHold = "OnHold",
  Completed = "Completed",
  Rejected = "Rejected",
  Archived = "Archived",
  None = "None",
}

export type RepairStatus = `${REPAIR_STATUS}`;
